import { render, staticRenderFns } from "./SupplierDataEdit.vue?vue&type=template&id=0e23941c&scoped=true"
import script from "./SupplierDataEdit.vue?vue&type=script&lang=js"
export * from "./SupplierDataEdit.vue?vue&type=script&lang=js"
import style0 from "./SupplierDataEdit.vue?vue&type=style&index=0&id=0e23941c&lang=scss&scoped=true"
import style1 from "./SupplierDataEdit.vue?vue&type=style&index=1&id=0e23941c&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e23941c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/devjobs/builds/JYRJr4p_y/0/supplyonline/covisint-cn-mcd/srm/mcd-srm-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0e23941c')) {
      api.createRecord('0e23941c', component.options)
    } else {
      api.reload('0e23941c', component.options)
    }
    module.hot.accept("./SupplierDataEdit.vue?vue&type=template&id=0e23941c&scoped=true", function () {
      api.rerender('0e23941c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/page/settlementUnit/SupplierDataEdit.vue"
export default component.exports